import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MotifProgressBar from '@ey/motif-react-wrapper/ProgressBar';

export default function ProgressBar({
	className,
	value,
	circle,
	error,
	isIndeterminate,
	labelComponent,
	hideLabel,
	size
}) {
	return (
		<StyledProgressBar
			className={className}
			value={value}
			circle={circle}
			error={error}
			isIndeterminate={isIndeterminate}
			hideLabel={hideLabel}
			labelComponent={labelComponent ? labelComponent : ''}
			size={size}
		/>
	);
}

ProgressBar.propTypes = {
	className: PropTypes.string,
	value: PropTypes.number,
	circle: PropTypes.bool,
	error: PropTypes.bool,
	isIndeterminate: PropTypes.bool,
	labelComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
	size: PropTypes.string
	/**
	 * One of 'xs' | 'sm' | 'md' | 'lg' | 'xl'
	 */
};

ProgressBar.defaultProps = {
	className: 'styled-progress-bar',
	value: 0,
	circle: false,
	error: false,
	isIndeterminate: true,
	hideLabel: false
};

const StyledProgressBar = styled(MotifProgressBar)`
	position: absolute;
	.motif-progress-bar {
		width: var(--px-20);
		height: var(--px-20);
	}
	.motif-progress-bar.motif-progress-bar-circle,
	.motif-progress-bar.motif-progress-bar-circle.motif-progress-bar-indeterminate {
		width: var(--px-50) !important;
		height: var(--px-50) !important;
	}
`;
